import "./styles/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { createQueryClient, Providers } from "./app/Providers";

const client = createQueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers client={client}>
      <App />
    </Providers>
  </StrictMode>,
);
